import { Component } from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-contact',
  imports: [TranslateModule],
  standalone: true,
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {
  constructor(public translate: TranslateService) {}
}
